module.exports = __webpack_public_path__ + "media/misc/fade-base-new-b86c065b.png";